module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jzhv4"))).then(() => parcelRequire('dJXJK'));